module.exports = __webpack_public_path__ + "static/media/5.c007d5b4.svg";